
const SplitTrackTypes = [
  { name: 'dialogue', placeholder: 'Dialogue File', title: 'Dialogue File' },
  { name: 'music', placeholder: 'Music File', title: 'Music File' },
  { name: 'sfx', placeholder: 'SFX File', title: 'SFX File' },
  { name: 'ambience', placeholder: 'Ambience File', title: 'Ambience File' },
]

export { SplitTrackTypes }